import { useState, useEffect, useCallback, useRef } from 'react';
import api from 'services/api';
import { useTenant } from 'context/TenantContext';
import { exportPagePdf } from 'utils/exportPdf';

export default function FluxTresoreriePage() {
  // Identite du TENANT pour l'en-tete/pied des exports PDF.
  // Sans raison sociale, NIF et RCCM, l'export est REFUSE (cf. utils/exportPdf.js).
  const tenant = useTenant();
  const [mouvements, setMouvements] = useState([]);
  const printRef = useRef();
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try { const r = await api.get('/comptabilite/tresorerie'); setMouvements(r.data); } catch {} finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const classify = (m) => {
    const cat = (m.categorie || '').toLowerCase();
    if (['investissement', 'achat materiel', 'achat equipement'].some(k => cat.includes(k))) return 'investissement';
    if (['apport', 'emprunt', 'financement', 'remboursement'].some(k => cat.includes(k))) return 'financement';
    return 'exploitation';
  };

  const sections = { exploitation: { label: 'Exploitation', items: [], total: 0 }, investissement: { label: 'Investissement', items: [], total: 0 }, financement: { label: 'Financement', items: [], total: 0 } };

  mouvements.forEach(m => {
    const cls = classify(m);
    const val = m.type === 'entree' ? Number(m.montant) : -Number(m.montant);
    sections[cls].items.push(m);
    sections[cls].total += val;
  });

  const total = Object.values(sections).reduce((s, sec) => s + sec.total, 0);

  if (loading) return <p style={{ textAlign: 'center', padding: '3rem', color: 'var(--gss-text-light)' }}>Chargement...</p>;

  return (
    <div>
      <div className="gss-toolbar" style={{ marginBottom: 16 }}>
        <div />
        <button className="gss-btn gss-btn-primary" onClick={() => exportPagePdf('Flux de trésorerie', printRef.current, tenant)}>Exporter PDF</button>
      </div>
      <div ref={printRef}>
      <div className="stats-grid stats-grid--3">
        {Object.entries(sections).map(([k, sec]) => (
          <div key={k} className="stat-card">
            <div className="stat-card-header"><span className="stat-card-label">{sec.label}</span></div>
            <div className="stat-card-value" style={{ color: sec.total >= 0 ? '#2e7d32' : '#DC2626' }}>{sec.total.toLocaleString()}</div>
            <div className="stat-card-sub">FCFA</div>
          </div>
        ))}
      </div>

      {Object.entries(sections).map(([k, sec]) => (
        <div key={k} className="content-card" style={{ marginBottom: 16 }}>
          <div className="content-card-title">{sec.label}</div>
          {sec.items.length === 0 ? (
            <p style={{ textAlign: 'center', padding: '1rem', color: 'var(--gss-text-light)' }}>Aucun mouvement</p>
          ) : (
            <div className="gss-table-wrap">
              <table className="gss-table">
                <thead><tr><th>Date</th><th>Libelle</th><th>Type</th><th>Montant</th></tr></thead>
                <tbody>
                  {sec.items.map(m => (
                    <tr key={m.id}>
                      <td>{m.date_mouvement?.split('T')[0]}</td>
                      <td>{m.libelle}</td>
                      <td><span style={{ color: m.type === 'entree' ? '#2e7d32' : '#DC2626' }}>{m.type === 'entree' ? 'Entree' : 'Sortie'}</span></td>
                      <td style={{ textAlign: 'right', fontWeight: 600, color: m.type === 'entree' ? '#2e7d32' : '#DC2626' }}>{Number(m.montant).toLocaleString()} F</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <div style={{ padding: '8px 16px', fontWeight: 700, textAlign: 'right', borderTop: '1px solid #eee' }}>Solde {sec.label} : {sec.total.toLocaleString()} FCFA</div>
        </div>
      ))}

      <div className="content-card" style={{ textAlign: 'center', padding: '1rem' }}>
        <span style={{ fontSize: 16, fontWeight: 800, color: total >= 0 ? '#2e7d32' : '#DC2626' }}>Flux net total : {total.toLocaleString()} FCFA</span>
      </div>
      </div>
    </div>
  );
}
